import { forwardRef, Ref } from 'react';
import { MotionBox, MotionBoxProps } from './Motion';

const DEFAULT_INITIAL = { opacity: 0, y: -300 };
const DEFAULT_ANIMATE = { opacity: 1, y: 0, transition: { duration: 0.3 } };
const DEFAULT_EXIT = { opacity: 0, y: -300, transition: { duration: 1.5 } };

export type SlideDownBoxProps = MotionBoxProps;

const SlideDownBoxInner = (
    { display = 'flex', flexDirection = 'column', ...props }: SlideDownBoxProps,
    ref: Ref<HTMLDivElement>
) => {
    return (
        <MotionBox
            {...props}
            ref={ref}
            display={display}
            flexDirection={flexDirection}
            initial={DEFAULT_INITIAL}
            animate={DEFAULT_ANIMATE}
            exit={DEFAULT_EXIT}
        />
    );
};

const SlideDownBox = forwardRef<HTMLDivElement, SlideDownBoxProps>(
    SlideDownBoxInner
);
export default SlideDownBox;
